/**
 * Ce qu'une facture pèse dans un total, selon les mêmes règles que le serveur
 * (`backend/app/core/metrics.py`). Les totaux de la page des factures et de
 * l'accueil comptaient les brouillons comme créances et les factures annulées
 * comme facturées, sans retirer les avoirs: trois écrans, trois chiffres.
 */

/** Statuts d'une facture qui reste à encaisser (`OPEN_INVOICE_STATUSES`). */
export const STATUTS_FACTURE_OUVERTE = new Set(['PENDING', 'SENT', 'PARTIAL', 'PARTIALLY_PAID', 'OVERDUE']);

const nombre = (valeur) => {
  const n = Number(valeur);
  return Number.isFinite(n) ? n : 0;
};

const statut = (facture) => String(facture?.status || '').toUpperCase();

export const estFactureOuverte = (facture) => STATUTS_FACTURE_OUVERTE.has(statut(facture));

/** Facturé: total moins avoirs, jamais négatif; zéro si annulée (`invoice_billed_amount`). */
export const montantFacture = (facture) => {
  if (statut(facture) === 'CANCELLED') return 0;
  return Math.max(nombre(facture?.total_amount) - nombre(facture?.credit_total), 0);
};

/** Reste à encaisser d'une facture ouverte, tel que le serveur l'a calculé. */
export const resteFacture = (facture) => {
  if (!estFactureOuverte(facture)) return 0;
  return nombre(facture?.amount_remaining ?? facture?.balance_due);
};

/** Somme au centime près, sans bruit binaire (0,1 + 0,2). */
export const sommeMontants = (montants) =>
  montants.reduce((somme, montant) => somme + Math.round(nombre(montant) * 100), 0) / 100;

/**
 * Marge estimée d'une commande: (prix − coût) × litres commandés.
 * Inconnue (`null`) sans prix ou sans coût d'achat, comme côté serveur:
 * compter un coût absent pour zéro faisait de tout le prix une marge.
 */
export const margeCommande = (commande) => {
  const prix = commande?.unit_price;
  const cout = commande?.unit_cost;
  if (prix === null || prix === undefined || prix === '' || cout === null || cout === undefined || cout === '') {
    return null;
  }
  return Math.round((nombre(prix) - nombre(cout)) * nombre(commande?.quantity_liters) * 100) / 100;
};
